export const jobDetailsSelector = state => state.jobDetails;
